import { render, staticRenderFns } from "./appManagement.vue?vue&type=template&id=61836513&scoped=true&"
import script from "./appManagement.vue?vue&type=script&lang=js&"
export * from "./appManagement.vue?vue&type=script&lang=js&"
import style0 from "./appManagement.vue?vue&type=style&index=0&id=61836513&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61836513",
  null
  
)

export default component.exports